shadow$provide[384] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `vec2 mapUV(vec4 uvwo, vec4 stpq) {
  return uvwo.xy;
}
`;

};